import { h, Component } from 'preact';
import classNames from 'classnames';
import styles from './submit_button_style';

let cx = classNames.bind(styles);

export default class SubmitButton extends Component {
	render({field}, {}) {
		var sizeClass = cx({
      field: true,
      Small: field.size === 'Small',
			Medium: field.size === 'Medium',
			Large: field.size === 'Large',
      XLarge: field.size === 'XLarge',
      submitButtonContainer: true
    });
		return (
			<div class={sizeClass}> 
        <input class="btn btn-primary" type="submit" value={field.label} />
      </div>
		);
	}
}



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/submit_button.js